import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'lib-datos-generales',
    templateUrl: './datos-generales.component.html',
    styleUrls: ['./datos-generales.component.css']
})
export class DatosGeneralesComponent implements OnInit {

    @Input()
    form: FormGroup = new FormGroup({});

    constructor() {
    }

    ngOnInit(): void {
        this.buildForm(this.form);
    }

    buildForm(form?: FormGroup) {
        form.addControl('titulo', new FormControl('', Validators.required))
        form.addControl('descripcion', new FormControl(''))
    }
}
